import styled from 'styled-components';

import { type ModalPaddingSizes, type TextAlignments } from '../../Modal.types';
import { MODAL_LAYOUT_SPACING, MODAL_SECTION_SPACING } from '../../tokens';

interface SectonWrapperProps {
    $alignEnd?: boolean;
    $padded?: boolean;
    $paddingSize: ModalPaddingSizes;
    $textAlign: TextAlignments;
}

export const LayoutWrapper = styled.div`
    --yat_modal-layout-gap: ${MODAL_LAYOUT_SPACING}px;

    grid-area: layout;

    display: flex;
    flex-direction: column;
    gap: var(--yat_modal-layout-gap);
    flex-grow: 1;
`;

export const SectionWrapper = styled.div<SectonWrapperProps>`
    display: grid;
    align-content: baseline;
    justify-items: center;
    gap: ${MODAL_SECTION_SPACING}px;
    margin-top: ${({ $alignEnd }) => $alignEnd && 'auto'};
    padding-left: ${({ $padded }) => $padded && `${MODAL_SECTION_SPACING}px`};
    padding-right: ${({ $padded }) => $padded && `${MODAL_SECTION_SPACING}px`};
    text-align: ${({ $textAlign }) => $textAlign};

    // Required to fix a layout quirk in Safari, where the
    // 'margin-top: auto;' causes the container to be pushed off-screen.
    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        margin-top: unset;

        padding-left: ${({ $padded }) => $padded && `${MODAL_LAYOUT_SPACING}px`};
        padding-right: ${({ $padded }) => $padded && `${MODAL_LAYOUT_SPACING}px`};
    }
`;
